import {
  IconBox,
  IconChecks,
  IconAlertTriangle,
  IconCalendar,
  IconCurrencyDollar,
  IconTrendingUp,
  IconMapPin,
} from '@tabler/icons-react';
import type { FilterPreset } from '@/components/ui/FilterModal';
import type { AssetFilter } from './AssetFilterContent';

export function getAssetFilterPresets(): FilterPreset<AssetFilter>[] {
  return [
    {
      id: 'all-assets',
      name: 'All Assets',
      description: 'Complete inventory of all assets',
      icon: <IconBox size={20} />,
      color: 'blue',
      filters: {},
      badge: 'Popular',
    },
    {
      id: 'available-assets',
      name: 'Available Assets',
      description: 'Assets ready for assignment',
      icon: <IconChecks size={20} />,
      color: 'green',
      filters: { status: ['Available'] },
    },
    {
      id: 'maintenance-needed',
      name: 'Maintenance',
      description: 'Assets currently in maintenance',
      icon: <IconAlertTriangle size={20} />,
      color: 'orange',
      filters: { status: ['Maintenance'] },
      badge: 'Action Required',
    },
    {
      id: 'recent-purchases',
      name: 'Recent Purchases',
      description: 'Assets purchased in last 30 days',
      icon: <IconCalendar size={20} />,
      color: 'violet',
      filters: {
        dateRange: {
          start: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
          end: new Date().toISOString().split('T')[0],
        },
      },
    },
    {
      id: 'high-value',
      name: 'High Value Assets',
      description: 'Assets worth $5,000 or more',
      icon: <IconCurrencyDollar size={20} />,
      color: 'yellow',
      filters: {
        costRange: {
          min: 5000,
          max: null,
        },
      },
    },
    {
      id: 'depreciable',
      name: 'Depreciable Assets',
      description: 'Assets being depreciated',
      icon: <IconTrendingUp size={20} />,
      color: 'cyan',
      filters: { isDepreciable: true },
    },
    {
      id: 'unassigned',
      name: 'Unassigned Assets',
      description: 'Assets without location or department',
      icon: <IconMapPin size={20} />,
      color: 'red',
      filters: {},
    },
  ];
}
